var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGpu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 18,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(-1384 -835)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 22,
    height: 22,
    transform: "translate(1384 835)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    transform: "translate(1386 837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M1.887,12.557H.711a.711.711,0,0,0,0,1.423H2.184a3.579,3.579,0,0,0,1.837,1.837v1.472a.711.711,0,1,0,1.422,0V16.114H8.256v1.174a.711.711,0,0,0,1.423,0V16.114h2.878v1.174a.711.711,0,0,0,1.423,0V15.817a3.582,3.582,0,0,0,1.837-1.837h1.472a.711.711,0,0,0,0-1.423H16.114V9.745h1.174a.711.711,0,0,0,0-1.423H16.114V5.443h1.174a.711.711,0,1,0,0-1.422H15.817A3.579,3.579,0,0,0,13.98,2.184V.711a.711.711,0,0,0-1.423,0V1.887H9.679V.711a.711.711,0,1,0-1.423,0V1.887H5.443V.711a.711.711,0,1,0-1.422,0V2.184A3.575,3.575,0,0,0,2.184,4.021H.711a.711.711,0,1,0,0,1.422H1.887V8.256H.711a.711.711,0,1,0,0,1.423H1.887Zm10.67,2.134H5.443A2.137,2.137,0,0,1,3.31,12.557V5.443A2.136,2.136,0,0,1,5.443,3.31h7.114a2.137,2.137,0,0,1,2.134,2.133v7.114a2.137,2.137,0,0,1-2.134,2.134m.283-8.579a.871.871,0,1,1-.871-.872.871.871,0,0,1,.871.872m-5.936,0a.872.872,0,1,1-.872-.872.872.872,0,0,1,.872.872m5.936,5.775a.871.871,0,1,1-.871-.872.872.872,0,0,1,.871.872m-5.936,0a.872.872,0,1,1-.872-.872.872.872,0,0,1,.872.872",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGpu);
export default __webpack_public_path__ + "static/media/icon-gpu.a0ab87626a105a5eeb51805894e1e237.svg";
export { ForwardRef as ReactComponent };